// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"9e8b6bc6","709":"909f49dd"}[chunkId] + ".chunk.css";
};